import React from 'react';
import { ProgressSummaryResponse } from './types';

interface Props {
  data: ProgressSummaryResponse;
  compact?: boolean;
}

const ProgressSummaryView: React.FC<Props> = ({ data, compact = false }) => (
  <div className="space-y-6">
    <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg">
      <h2 className="text-2xl font-bold mb-2">Progress Summary: {data.topic}</h2>
      <p className="text-sm text-muted-foreground">Since {data.since_date}</p>
      <p className={`mt-4 text-foreground ${compact ? 'line-clamp-4' : ''}`}>{data.summary}</p>
    </div>

    {!compact && data.key_updates?.length > 0 && (
      <div className="border border-green-200 dark:border-green-800 rounded-lg p-6">
        <h3 className="font-semibold mb-2">Key Updates</h3>
        <ul className="list-disc list-inside space-y-1 text-sm">
          {data.key_updates.map((u, i) => <li key={i}>{u}</li>)}
        </ul>
      </div>
    )}
  </div>
);

export default ProgressSummaryView;
